(function () {
  // Selects by the id prefix rather than an exact per-section id, so this
  // file needs no Liquid interpolation and works for however many
  // Slideshow-{{ section.id }} instances are on the page (normally one).
  var sections = document.querySelectorAll('[id^="Slideshow-"]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    function pickSrc(slide) {
      var w = window.innerWidth || document.documentElement.clientWidth || 1024;
      if (w >= 769) return slide.getAttribute('data-bg-desktop');
      if (w >= 521) return slide.getAttribute('data-bg-mobile');
      return slide.getAttribute('data-bg-small');
    }

    function hydrate(slide) {
      if (!slide || slide.__wbnHydrated) return;
      var src = pickSrc(slide);
      if (!src) return;
      var wrap = slide.querySelector('.hero__image-wrapper');
      if (!wrap) return;
      // Use an Image() to start the download cleanly, then swap in.
      var img = new Image();
      img.onload = function () {
        wrap.style.backgroundImage = 'url("' + src + '")';
        wrap.style.backgroundRepeat = 'no-repeat';
        wrap.style.backgroundSize = 'cover';
      };
      img.src = src;
      slide.__wbnHydrated = true;
    }

    // Hydrate the newly-selected slide plus one read-ahead.
    //
    // This carousel is Flickity (theme.Slideshow / theme.js), NOT slick, so we
    // watch for the `is-selected` class the carousel puts on the active slide
    // instead of binding library-specific events. That keeps this independent
    // of which carousel the theme ships and needs no instance reference.
    function hydrateFrom(slide) {
      hydrate(slide);
      var next = slide.nextElementSibling;
      // Read-ahead: autoplay dwells a few seconds per slide (see this
      // section's autoplay_speed setting), so the next image has time to
      // arrive before it is shown.
      if (next && next.classList.contains('slideshow__slide')) hydrate(next);
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        records.forEach(function (r) {
          var el = r.target;
          if (el.classList.contains('is-selected')) hydrateFrom(el);
        });
      }).observe(section, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // If the carousel is already up (e.g. this script ran after a section
    // re-render in the theme editor), hydrate the current slide right away.
    var selected = section.querySelector('.slideshow__slide.is-selected');
    if (selected) hydrateFrom(selected);

    // Always pre-warm slide #2 ~1s after load so the first user swipe is instant.
    window.addEventListener('load', function () {
      setTimeout(function () {
        var slides = section.querySelectorAll('.slideshow__slide');
        if (slides[1]) hydrate(slides[1]);
      }, 1000);
    });
  });
})();
